module.exports = __webpack_public_path__ + "static/media/web_Bianca-118-Edit.a2371665.jpg";